import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Crown, Sparkles, Lock } from 'lucide-react';

/**
 * Componente para mostrar CTA de upgrade a premium
 * 
 * Props:
 * - title: Título personalizado
 * - message: Mensaje personalizado
 * - feature: Feature específico que está bloqueado
 * - compact: Versión compacta del componente
 */
const UpgradePrompt = ({ 
  title = "Feature Premium",
  message = "Esta funcionalidad está disponible solo para usuarios Premium",
  feature = null,
  compact = false
}) => {
  const navigate = useNavigate();

  if (compact) {
    return (
      <div className="flex items-center justify-between p-4 bg-gradient-to-r from-blue-50 to-purple-50 border border-blue-200 rounded-lg">
        <div className="flex items-center gap-3">
          <Lock className="w-5 h-5 text-blue-600" />
          <div>
            <p className="font-semibold text-slate-900">{title}</p>
            <p className="text-sm text-slate-600">{message}</p>
          </div>
        </div>
        <Button
          size="sm"
          onClick={() => navigate('/pricing')}
          className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
        >
          <Crown className="w-4 h-4 mr-2" />
          Actualizar
        </Button>
      </div>
    );
  }

  return (
    <Card className="p-8 text-center bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 border-2 border-blue-200">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full mb-4">
        <Crown className="w-8 h-8 text-blue-600" />
      </div>

      <h3 className="text-2xl font-bold text-slate-900 mb-3">
        {title}
      </h3>

      <p className="text-slate-600 mb-6 max-w-md mx-auto">
        {message}
      </p>

      {feature && (
        <div className="mb-6 p-4 bg-white/80 rounded-lg border border-blue-200">
          <div className="flex items-center justify-center gap-2 text-blue-700 font-medium">
            <Sparkles className="w-5 h-5" />
            <span>{feature}</span>
          </div>
        </div>
      )}

      <div className="space-y-3">
        <Button
          size="lg"
          onClick={() => navigate('/pricing')}
          className="w-full max-w-xs bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
        >
          <Crown className="w-5 h-5 mr-2" />
          Ver Planes Premium
        </Button>

        <p className="text-sm text-slate-500">
          🎁 7 días de prueba gratis - Cancela cuando quieras
        </p>
      </div>

      <div className="mt-6 pt-6 border-t border-blue-200">
        <p className="text-xs text-slate-500">
          💰 Precio de lanzamiento: Solo $99 MXN/mes
        </p>
        <p className="text-xs text-slate-500">
          Los primeros usuarios mantienen este precio de por vida
        </p>
      </div>
    </Card>
  );
};

export default UpgradePrompt;
